/** The pages of /simulador. */

export type GameTab = 'hoy' | 'hermandad' | 'vida' | 'personajes' | 'logros' | 'ajustes';

export type SimRoute =
  | { page: 'game'; tab: GameTab }
  | { page: 'register' }
  | { page: 'login' }
  | { page: 'forgot' }
  | { page: 'reset'; token: string }
  | { page: 'verify'; token: string }
  | { page: 'unsubscribe'; key: string }
  | { page: 'privacy' }
  | { page: 'terms' }
  | { page: 'share'; id: string }
  | { page: 'admin' }
  | { page: 'not_found' };

const TABS: Record<string, GameTab> = {
  '': 'hoy',
  hermandad: 'hermandad',
  vida: 'vida',
  personajes: 'personajes',
  logros: 'logros',
  ajustes: 'ajustes',
};

export const isSimPath = (path: string): boolean =>
  path === '/simulador' || path.startsWith('/simulador/');

export function parseSimRoute(path: string, search: string): SimRoute {
  const rest = path.replace(/\/+$/, '').replace(/^\/simulador\/?/, '');
  const q = new URLSearchParams(search);
  if (rest in TABS) return { page: 'game', tab: TABS[rest]! };
  switch (rest) {
    case 'registro':
      return { page: 'register' };
    case 'entrar':
      return { page: 'login' };
    case 'recuperar':
      return { page: 'forgot' };
    case 'contrasena':
      return { page: 'reset', token: q.get('token') ?? '' };
    case 'verificar':
      return { page: 'verify', token: q.get('token') ?? '' };
    case 'baja':
      return { page: 'unsubscribe', key: q.get('key') ?? '' };
    case 'privacidad':
      return { page: 'privacy' };
    case 'condiciones':
      return { page: 'terms' };
    case 'admin':
      return { page: 'admin' };
  }
  const share = /^logro\/([a-z2-9]{10})$/.exec(rest);
  if (share) return { page: 'share', id: share[1]! };
  return { page: 'not_found' };
}

export const tabPath = (tab: GameTab): string =>
  tab === 'hoy' ? '/simulador' : `/simulador/${tab}`;
